import { HENI_TAG_LABEL } from '#lib/websites/news/constants/heni-tag.js';

// Exact match, case- and whitespace-insensitive ("heni", "HENI", " Heni ").
// Used for the Enter key: "heni talks" is an ordinary phrase search, and
// hijacking Enter for it would strand the user on the HENI feed.
export const isHeniSearch = (searchValue: string | undefined | null) =>
	searchValue?.trim().toLowerCase() === HENI_TAG_LABEL.toLowerCase();

// Substring match, used to offer the HENI tag as a *suggestion*. Wider than
// isHeniSearch because a suggestion is opt-in — the user still has to click it —
// so surfacing it for "heni talks" is helpful rather than disruptive.
export const includesHeniSearch = (searchValue: string | undefined | null) =>
	Boolean(
		searchValue?.trim().toLowerCase().includes(HENI_TAG_LABEL.toLowerCase())
	);
